import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { GlassCard } from '../UI/GlassCard';
import { motion, AnimatePresence } from 'framer-motion';

export const FeaturesGrid = () => {
  const { t } = useLanguage();
  const [showAll, setShowAll] = useState(false);

  // Все 20 оригинальных элементов, эмодзи заменены на соответствующие иконки Font Awesome
  const featureKeys = [
    { key: 'relogin', icon: 'fa-sync-alt' },
    { key: 's2td', icon: 'fa-save' },
    { key: 'td2s', icon: 'fa-folder' },
    { key: 'warmup', icon: 'fa-fire' },
    { key: 'vtope', icon: 'fa-chart-line' },
    { key: 'automsg', icon: 'fa-comments' },
    { key: 'autolike', icon: 'fa-heart' },
    { key: 'autocomment', icon: 'fa-pen-nib' },
    { key: 'checker', icon: 'fa-check-circle' },
    { key: 'unblock', icon: 'fa-shield-alt' },
    { key: 'admininvite', icon: 'fa-crown' },
    { key: 'reports', icon: 'fa-exclamation-triangle' },
    { key: 'randomizer', icon: 'fa-random' },
    { key: 'stories', icon: 'fa-camera' },
    { key: 'interceptor', icon: 'fa-user-secret' },
    { key: 'chatcloner', icon: 'fa-users' },
    { key: 'webchat', icon: 'fa-globe' },
    { key: 'offerphoto', icon: 'fa-image' },
    { key: 'chancloner', icon: 'fa-bullhorn' },
    { key: 'autoinvite', icon: 'fa-handshake' }
  ];

  // Показывать первые 6 по умолчанию, или все 20 при нажатии кнопки
  const visibleFeatures = showAll ? featureKeys : featureKeys.slice(0, 6);

  return (
    <section className="features-section" id="features">
      <div className="section-header">
        <h2 className="section-title">{t('features.title')}</h2>
        <p className="section-subtitle">{t('features.subtitle')}</p>
        <span className="section-line" />
      </div>

      <div className="features-grid-container">
        <motion.div layout className="features-grid">
          <AnimatePresence mode="popLayout">
            {visibleFeatures.map((item) => (
              <motion.div
                key={item.key}
                layout
                initial={{ opacity: 0, scale: 0.92 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.92 }}
                transition={{ duration: 0.25 }}
              >
                <GlassCard className="feature-card" hoverEffect={true}>
                  <div className="feature-icon-wrapper">
                    <i className={`fas ${item.icon} feature-icon`}></i>
                  </div>
                  <h3 className="feature-card-title">
                    {t(`features.items.${item.key}.title`)}
                  </h3>
                  <p className="feature-card-desc">
                    {t(`features.items.${item.key}.desc`)}
                  </p>
                </GlassCard>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      <div className="features-toggle-bar" style={{ marginTop: '40px', textAlign: 'center' }}>
        <button 
          className="btn-secondary toggle-view-btn"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? t('features.hideAll') : t('features.showAll')}
        </button>
      </div>
    </section>
  );
};

export default FeaturesGrid;